// Empty stub for Node.js-only modules that don't work in browser
export default {};
export const Client = class {};
